import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import { BannerNotificationType } from "../../components/SimpleNotification";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

import { axiosApiInstance } from "../../axios";

export function CreditReturnsViewModel(logout) {
  const defaultFilters = {
    customer: { value: -1, label: "All customers" },
    startDate: null,
    endDate: null,
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [creditReturns, setCreditReturns] = useState([]);
  const [totalCreditReturns, setTotalCreditReturnss] = useState(0);
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [customers, setCustomers] = useState([]);

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getCreditReturns = async function (search, page) {
    const payload = {
      page: page,
      search: search,
      filter: filters,
    };
    let callResult = await makePostApiCall(`creditReturns`, payload);
    if (callResult.success) {
      const response = callResult.data;
      if (page > 1) {
        setCreditReturns([...creditReturns, ...response.data]);
      } else {
        setLoading(false);
        setCreditReturns(response.data);
        setTotalCreditReturnss(response.total);
      }
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  //   const deleteCreditReturn = async function (creditReturnId, index) {
  //     let callResult = await makePostApiCall(`deleteCreditReturn/${creditReturnId}`, {});
  //     if (callResult.success) {
  //       setEmptyModelOpen({
  //         open: false,
  //         childComponent: null,
  //       });
  //       getCreditReturns(null, 0);
  //       setShowSimpleNotification({
  //         show: true,
  //         title: callResult.data.message,
  //         type: BannerNotificationType.Success,
  //       });
  //     } else {
  //       if (callResult.errorStatus === 401) {
  //         logout();
  //       }
  //       showErrorModal(callResult.data.message);
  //     }
  //   };

  //   const askDeleteCreditReturn = function (creditReturn, index) {
  //     if (creditReturn.status === 5 || creditReturn.status === 11) {
  //       showErrorModal("Shipped or voided credit returns cannot be deleted");
  //     } else {
  //       setEmptyModelOpen({
  //         childComponent: (
  //           <DeleteConfirmationForm
  //             buttonMessage="Delete"
  //             confirmAction={() => deleteCreditReturn(creditReturn.id, index)}
  //             message={`Are you sure you want to delete ${creditReturn.po_number} for ${creditReturn.customer_name}?`}
  //             setOpen={setEmptyModelOpen}
  //           />
  //         ),
  //         open: true,
  //       });
  //     }
  //   };

  const filterComponents = [
    <DateRangeFilter
      startDate={filters.startDate}
      endDate={filters.endDate}
      onChange={(name, value) =>
        setFilters({
          ...filters,
          [name]: value,
        })
      }
      resetFilter={() => setFilters(defaultFilters)}
    />,
    <FilterSingleSelectDropdown
      header="Customer"
      onChange={(value) =>
        setFilters({
          ...filters,
          customer: value,
        })
      }
      options={customers}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="customer"
      value={filters.customer}
    />,
  ];

  const resetFilters = () => {
    const filterReset = {
      customer: { value: -1, label: "All customers" },
      startDate: null,
      endDate: null,
    };
    setFilters(filterReset);

    setShowFilters(false);
    getCreditReturns(null, 1, filterReset);
  };

  const getCustomers = async function () {
    let callResult = await makeGetApiCall(`customersForDropdown`);
    if (callResult.success) {
      setCustomers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const printShipments = async function () {
    try {
      const user_id = localStorage.getItem("id") * 1;
      const user_name = localStorage.getItem("name");

      const payload = {
        filter: filters,
        user_id,
        user_name,
      };

      const response = await axiosApiInstance.post(
        `/creditReturns/print`,
        payload,
        {
          responseType: "blob", // important!
          headers: {
            Authorization: "Bearer " + localStorage.getItem("authToken"),
            "Content-Type": "application/json",
          },
        }
      );

      // create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "credit_returns.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      if (err.response?.status === 401) {
        logout();
      } else {
        console.error("Download failed:", err);
      }
    }
  };

  return {
    emptyModal,
    getCreditReturns,
    loading,
    creditReturns,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    filters,
    showFilters,
    setShowFilters,
    filterComponents,
    resetFilters,
    getCustomers,
    printShipments,
    totalCreditReturns,
  };
}
